export default {
    search: 'Search',
    searchText: 'Search by visitor name',
    exportPDF: 'Export PDF',
    exportExcel: 'Export excel',
    visitorName: 'Visitor Name',
    contact: 'Contact',
    contactNo: 'Contact No.',
    date: 'Date',
    time: 'Time',
    image: 'Image',
    location: 'Location',
    temp: 'Temp',
    somethingWrong: 'Something went wrong'
}
